import React, { useEffect,useRef, useState } from "react";
// import h5Share from '@/utils/h5Share'
import styled from "styled-components";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import styles from '@/styles'
import Goods from './goods.json';
import PayResult from './components/PayResult';
import ReactDOM from 'react-dom';
// import bridge from '@/config/JSbridge'
import bridge from '@/config/JSbridge';
import { getObjectFormSerach } from '@/utils';
import { Line } from './style'
import { connect } from 'react-redux'

// const PayResult = React.lazy(() => import('./components/PayResult'));
export const isStorm = bwmodel.app === 'storm';

// const active_id = 140;


const App = ({props,userId}) => {
  const search = getObjectFormSerach(props.location.search);
  const {id, vip, showTime } = search;
  
  const [goodsList, setGoodsList] = useState([]);
  const [isVip, setIsVip] = useState(false);
  const [money, setMoney] = useState(false);
  const [isShowTime,setIsShowTime] = useState(false); //]
  const payResultRef = useRef();
 
  useEffect(()=> {   
    if(showTime === 'true') {
      setIsShowTime(true);
    }
    if(vip === "true") {
      setIsVip(true);
      setGoodsList(Goods);
      setMoney(6316);
    } else  if(id) {
      let num = 0;
      const ids = id.split(":");
      const list = Goods.filter((it,index) => {
        if(ids[index] === '1') {
          num = num + it.price;
          return true;
          
        }
        return false;
      })
      setGoodsList(list);
    
      // console.log(list);
     
      // list.forEach((a,b) =>  {
      //   console.log(a.price);
      //   return a.price  + b.price; 
      // });

      console.log(num );
      const money = num - 999 * list.length - 1;

      setMoney( money )
    }
     
  },[]);

  function liveApp() {
    bridge.callHandler('nativeEvent', {event: 'close', params: {
      isDelete: false
    }}, () => {})
  }
  const hanlePay = () => {

    // if(process.env.NODE_ENV === 'development'){
    //   localStorage.setItem('active135_isVip',JSON.stringify(false));
    //   localStorage.setItem('active135_skuIds', JSON.stringify([0,0,0,0,0,0,0,0]) );
    //   localStorage.setItem(`active135_${userId}_isBuy`, JSON.stringify(true));
    //   localStorage.setItem('active135_num', 0)
    //   localStorage.setItem('active135_goods_list', JSON.stringify([]))

    //   payResultRef.current.show();
    //   return 

    // }
    let skuId = [];
    let orderType = '1';
    if(isVip) {
      
      skuId = [3];
    }else {
      id.split(":").forEach((it,index) => {
        if(it === '1' ) {
          skuId.push(Goods[index].id);
        }
      });
      let result = Goods.find(it => it.id === Number(skuId[0]));
      orderType = result.spu_id;
    }

    let payMoney = '0';
    let iapId = '';
    if(isVip) {
      payMoney = "3888";
      // payMoney = '0.01';
      iapId = 'valuestorm.cloudconch.3888'
    } else if(skuId.length === 2) {
      payMoney = "1999";
      // payMoney = '0.02';
       iapId = 'valuestorm.cloudconch.1999'
    } else if(skuId.length === 3) {
      // payMoney = '0.03';
      payMoney = '2998';
      iapId = 'valuestorm.cloudconch.2998'
    }

    bridge.callHandler('nativeEvent', {
      // event: (isiOS &&  bwmodel.compareVersion('6.12.0')) ?"iOSIAPPay":  'halfScreenPay',
      event: 'halfScreenPay',
      params: {
        price: payMoney,
        iapId: iapId,
        activityTitle: '九月大礼包',
        skuId: skuId.join(':'),
        orderType: `${orderType}`
      },
    }, (params) => {
      try {
      
        const info = JSON.parse(params);
        if (info && info.params.result) {
          localStorage.setItem('active135_isVip',JSON.stringify(false));
          localStorage.setItem('active135_skuIds', JSON.stringify([0,0,0,0,0,0,0,0]) );
          localStorage.setItem(`active135_${userId}_isBuy`, JSON.stringify(true));
          localStorage.setItem('active135_num', 0)
          localStorage.setItem('active135_goods_list', JSON.stringify([]))


          // Cookies.set('`active135_${userId}_isBuy`', JSON.stringify(true), { expires: 7 });

          payResultRef.current.show();

        }
      } catch (error) {
        //
        console.log(error);
      }
    })
  }

 
  return (
    <Container style={isStorm ? {} : {paddingTop: '10px'}} >
      {isStorm && 
        <Header
          title="结算"
          hideNaviBar
          bg_color={styles.bg_color2}
        />
      }
      {
        isVip && 
        <React.Fragment>
          <GoodsCard>
          <div className="img_box">
          <img src={require(`./imgs/${'goods9.png'}`)} alt=""></img>
          </div>
          <div className="content">
            <div className="title"><span className="name">打包所有会员（风云大会员）</span></div>
            <div><span className="price1">打包¥3888</span></div>
          </div>
        </GoodsCard>
        <div className="segmentation"> <span className="content">打包购买后包含以下会员&周边1套</span> <span className="line2"></span> </div>
      </React.Fragment>
     }
      {
        goodsList.map((it) => {
          return <GoodsCard>
            <div className="img_box"
             
            >
              <img src={require(`./imgs/${it.img}`)} alt=""></img>
            </div>
            <div className="content"
              
            >
              <div className="title"><span className="name">{it.name}·年会员</span></div>
              <div><span className="price1"> {isVip ? '打包后¥0':'活动价¥1000'}</span><span className="price2">单买¥{it.price}</span></div>
            </div>
          </GoodsCard>
        })
      }
      {
       isVip && 
        <React.Fragment>
         
          <GoodsCard>
            <div className="img_box">
              <img src={require(`./imgs/${'goods12.png'}`)} alt=""></img>
            </div>
            <div className="content"
            
            >
              <div className="title"><span className="name">易融术·年会员</span></div>
              <div><span className="price1">打包赠送</span></div>
            </div>
          </GoodsCard>
          <GoodsCard>
            <div className="img_box">
              <img src={require(`./imgs/${'goods13.png'}`)} alt=""></img>
            </div>
            <div className="content"
            
            >
              <div className="title"><span className="name">估值挖掘机·年会员</span></div>
              <div><span className="price1">打包赠送</span></div>
            </div>
          </GoodsCard>
          <GoodsCard>
            <div className="img_box">
              <img src={require(`./imgs/${'goods10.png'}`)} alt=""></img>
            </div>
            <div className="content"
            
            >
              <div className="title"><span className="name">锦鲤卡·年会员</span></div>
              <div><span className="price1">打包赠送</span></div>
            </div>
          </GoodsCard>
        </React.Fragment>
      }
      <Line />
        <GoodsCard>
            <div className="img_box"
             
            >
              <img src={require(`./imgs/${'goods11.png'}`)} alt=""></img>
            </div>
            <div className="content"
             
            >
              <div className="title"><span className="name">大鳄周边1套</span></div>
              <div><span className="price2">免费赠送（数量有限）</span></div>
            </div>
          </GoodsCard>
      <CardFooter >
     

        <div className="bg">现在购买所购会员天数都为{isShowTime?<span>402</span>:<span>372</span>}天</div>
        
        <div className="submitBar">
          <div className="submitBar_left">
            <div className="total">合计: <span>¥</span><span className="money">
              {
                isVip? '3888': goodsList.length === 2 ? '1999': (goodsList.length === 3 && "2998")
              }
              </span></div>
            <div className="money">立省{money}元</div>
          </div>
          <div className="btn"
            onClick={()=> {
              hanlePay();
            }}
          >立即支付</div>
        </div>
      </CardFooter>
       {
         ReactDOM.createPortal(
          <PayResult ref={payResultRef}  onSubmit={()=> {
            // history.goBack();
            liveApp()
          }}/>,
            document.body
         )
       }
     
    </Container>
  )
}
// export default  ;
const mapStateToProps = (state) => ({
  userId: state.user.userId || '', 
});

export default React.memo(connect(mapStateToProps)(App))


const Container = styled.div`
  padding-top: 54px;
  background: #F1F1F1;
  min-height: 100vh;
  padding-bottom: 100px;
  box-sizing: border-box;
  .segmentation {
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 12px;
    color: #717171;
    text-align: center;
    width:100%;
    position: relative;
    height: 20px;
    padding:0 14px;
    margin: 10px 0;
    box-sizing: border-box;
    .content {
      position: absolute;
      left: 50%;
      top: 4px;
      display: inline-block;
      background-color:#F1F1F1;
      white-space: nowrap;
      padding:0 20px;
      transform: translateX(-50%);
      
    }
    .line2 {
      border-top: 1px solid #727272 !important;
      display: inline-block;
      width: 100%;
  
    }
  }
`


const GoodsCard = styled.div`
  margin: 0 12px;
  height: 88px;
  padding: 7px 7px;
  border-radius: 10px;
  background-color:#fff;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  & + & {
    margin-top: 10px;
  }
  .img_box {
    width: 73px;
    height: 73px;
    img {
      width: 100%;
      height: 100%;
    }
  }
 
  .content {
    flex: 1;
    padding-left:6px;
    letter-spacing: 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .title {
    .name {
      font-family: Alibaba PuHuiTi;
      font-weight: 800;
      font-size: 15px;
      color: #000000;
      line-height:28px;
    }
    .days {
      color: #FF3E53;
      font-weight: 800;
    }
  }
  .price1 {
    font-family: Arial Black;
    font-weight: 700;
    font-size: 16px;
    color: #FF3E54;
    line-height: 29px;
  }
  .price2 {
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 12px;
    color: #6E6E6E;
    line-height: 26px;
    margin-left:4px;
  }
`;

const CardFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #dfdfdf;
  width: 100%;
  // height: 54px;
  background: #4C4C4C;

  .bg {

    color: #FFF;
    text-align: center;
    height: 24px;
    line-height: 24px;
    .money {
      color: #FFA200;
    }
    .btn2 {
      background: linear-gradient(148deg, #FF3061, #FF6C00);
      border-radius: 8px;
      height: 18px;
      display: inline-block;
      line-height:18px;
      padding : 0 8px;
    }
  }
  .submitBar {
    width: 100%;
    height: 69px;
    background: #FFFFFF;
    border-radius: 10px 10px 0px 0px;
    display: flex;
    align-items: center;
    padding: 0 13px;
    box-sizing: border-box;
    justify-content: space-between;
    .submitBar_left {
      .total {
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        font-size: 18px;
        color: #222222;

        span {
          font-weight: bold;
          
          color: #FF3E4C;
        }
        .money {
          font-size: 30px;
        }
      }
      .money { font-size: 13px;  color: #ff3e4c; }
    }
    .btn {
      // width: 94px;
      padding:0 18px;
      height: 44px;
      background: linear-gradient(148deg, #FF3061, #FF9000);
      border-radius: 22px;
      text-align: center;
      align-items: center;
      line-height: 44px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 24px;
      color: #FFFFFF;
    }
  }
  
`


// WEBPACK FOOTER //
// ./src/views/activity_135/settle.js